export enum LightControl {
    MANUAL = "MANUAL",
    AUTOMATIC = "AUTOMATIC",
}

export const LIGHT_CONTROL_TYPES = [
    { value: LightControl.MANUAL, label: "Manuální", selected: false },
    { value: LightControl.AUTOMATIC, label: "Automatické", selected: false },
]